const mimetypeElmt = document.getElementById('mimetype')
export default () => mimetypeElmt && mimetypeElmt.value === 'application/x-ownpad'
